"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _constant = require("./constant");

var _constant2 = _interopRequireDefault(_constant);

var _connect = require("./bridge/connect");

var _connect2 = _interopRequireDefault(_connect);

var _extension = require("./bridge/extension");

var _extension2 = _interopRequireDefault(_extension);

var _alias = require("./bridge/alias");

var _alias2 = _interopRequireDefault(_alias);

var _platform = require("./util/platform");

var _platform2 = _interopRequireDefault(_platform);

var _version = require("./util/version");

var _version2 = _interopRequireDefault(_version);

var _function = require("./util/function");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function initVersion() {
  var myVersion = _version2.default.get;
  _underscore2.default.each(_version2.default.compare, function (fuc, name) {
    myVersion[name] = function (right) {
      return fuc(_version2.default.get(), right);
    };
  });
  return myVersion;
}

var Bridge = function () {
  function Bridge(config) {
    _classCallCheck(this, Bridge);

    this._config = _underscore2.default.assign({}, config, {
      timeout: _constant2.default.DEFAULT_TIMEOUT_LIMIT
    });
    this.version = initVersion();
    this.platform = (0, _platform2.default)();
    this.config = this.config.bind(this);
    this.invoke = this.invoke.bind(this);
    this.toUrl = this.toUrl.bind(this);
    this.register = this.register.bind(this);
  }

  _createClass(Bridge, [{
    key: "config",
    value: function config(key, val) {
      if (!val) {
        return this._config(key);
      }
      this._config[key] = val;
      return this;
    }
  }, {
    key: "test",
    value: function test() {
      console.log("test");
    }
  }, {
    key: "invoke",
    value: function invoke(type) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var self = this;
      var onCallback = data.onCallback;
      var dataJson = JSON.stringify(_underscore2.default.omit(data, "onCallback"));
      var isFino = this.platform.app.isFino();
      if (isFino && this.platform.os.isIOS()) {
        return _connect2.default.ios().then(function (bridge) {
          return new Promise(function (res, rej) {
            return bridge.callHandler("MallBindJs", {
              type: type,
              dataJson: dataJson
            }, function (result) {
              if (onCallback) {
                return onCallback(result);
              }
              return res(result);
            });
          });
        }).catch(function (e) {
          alert(e);
        });
      }
      if (isFino && this.platform.os.isAndroid()) {
        return _connect2.default.android(window.MallBindJs, "ActionDataToApp").then(function (bridge) {
          return new Promise(function (res, rej) {
            return bridge.invoke(type, dataJson, function (result) {
              if (onCallback) {
                return onCallback(result);
              }
              return res(result);
            });
          });
        });
      }
      throw "ERROR.UNKNOWN_PLATFORM";
    }
  }, {
    key: "register",
    value: function register(func) {
      var isFino = this.platform.app.isFino();
      if (isFino && this.platform.os.isIOS()) {
        return _connect2.default.ios().then(function (bridge) {
          return bridge.registerHandler("IOSMallBridge", function (data) {
            func(data);
          });
        });
      }
      if (isFino && this.platform.os.isAndroid()) {
        return _connect2.default.android(window.MallBindJs, "ActionDataToApp").then(function (bridge) {
          return bridge.registerHandler("AndroidMallBridge", function (data) {
            func(data);
          });
        });
      }
      throw "ERROR.UNKNOWN_PLATFORM";
    }
  }, {
    key: "toUrl",
    value: function toUrl(addr) {
      return location.href = addr;
    }
  }, {
    key: "redirectToH5",
    value: function redirectToH5(type) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var toUrl = (0, _function.getActionPath)({
        actionType: type,
        actionData: data
      });
      window.location.href = toUrl;
    }
  }]);

  return Bridge;
}();

var init = function init() {
  var ext = (0, _extension2.default)(Bridge);
  ext.normal("redirect", _alias2.default.redirect);
  ext.normal("share", _alias2.default.share);
  ext.normal("ui", _alias2.default.ui);
  ext.normal("info", _alias2.default.info);
  ext.listen(_alias2.default.listen);
};

init();

var bridge = new Bridge();

exports.default = bridge;